function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/history
 */

/**
 * `History` keeps the track of all the operations applied to the {@link module:engine/model/document~Document document}.
 */
var History =
/*#__PURE__*/
function () {
  /**
   * Creates an empty History instance.
   */
  function History() {
    _classCallCheck(this, History);

    /**
     * Operations added to the history.
     *
     * @protected
     * @member {Array.<module:engine/model/operation/operation~Operation>} module:engine/model/history~History#_operations
     */
    this._operations = [];
    /**
     * Holds an information which {@link module:engine/model/operation/operation~Operation operation} undoes which
     * {@link module:engine/model/operation/operation~Operation operation}.
     *
     * Keys of the map are "undoing operations", that is operations that undone some other operations. For each key, the
     * value is an operation that has been undone by the "undoing operation".
     *
     * @private
     * @member {Map} module:engine/model/history~History#_undoPairs
     */

    this._undoPairs = new Map();
    /**
     * Holds all undone operations.
     *
     * @private
     * @member {Set.<module:engine/model/operation/operation~Operation>} module:engine/model/history~History#_undoneOperations
     */

    this._undoneOperations = new Set();
  }
  /**
   * Adds an operation to the history.
   *
   * @param {module:engine/model/operation/operation~Operation} operation Operation to add.
   */


  _createClass(History, [{
    key: "addOperation",
    value: function addOperation(operation) {
      if (this._operations.includes(operation)) {
        return;
      }

      this._operations.push(operation);
    }
    /**
     * Returns operations added to the history.
     *
     * @param {Number} [from=Number.NEGATIVE_INFINITY] Base version from which operations should be returned (inclusive).
     * Defaults to `Number.NEGATIVE_INFINITY`, which means that operations from the first one will be returned.
     * @param {Number} [to=Number.POSITIVE_INFINITY] Base version up to which operations should be returned (exclusive).
     * Defaults to `Number.POSITIVE_INFINITY` which means that operations up to the last one will be returned.
     * @returns {Array.<module:engine/model/operation/operation~Operation>} Operations added to the history.
     */

  }, {
    key: "getOperations",
    value: function getOperations() {
      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.NEGATIVE_INFINITY;
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.POSITIVE_INFINITY;
      var operations = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._operations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var operation = _step.value;

          if (operation.baseVersion >= from && operation.baseVersion < to) {
            operations.push(operation);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return operations;
    }
    /**
     * Returns operation from the history that bases on given `baseVersion`.
     *
     * @param {Number} baseVersion Base version of the operation to get.
     * @returns {module:engine/model/operation/operation~Operation|undefined} Operation with given base version or `undefined` if
     * there is no such operation in history.
     */

  }, {
    key: "getOperation",
    value: function getOperation(baseVersion) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this._operations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var operation = _step2.value;

          if (operation.baseVersion == baseVersion) {
            return operation;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
    /**
     * Marks in history that one operation is an operation that is undoing the other operation. By marking operation this way,
     * history is keeping more context information about operations, which helps in operational transformation.
     *
     * @param {module:engine/model/operation/operation~Operation} undoneOperation Operation which is undone by `undoingOperation`.
     * @param {module:engine/model/operation/operation~Operation} undoingOperation Operation which undoes `undoneOperation`.
     */

  }, {
    key: "setOperationAsUndone",
    value: function setOperationAsUndone(undoneOperation, undoingOperation) {
      this._undoPairs.set(undoingOperation, undoneOperation);

      this._undoneOperations.add(undoneOperation);
    }
    /**
     * Checks whether given `operation` is undoing any other operation.
     *
     * @param {module:engine/model/operation/operation~Operation} operation Operation to check.
     * @returns {Boolean} `true` if given `operation` is undoing any other operation, `false` otherwise.
     */

  }, {
    key: "isUndoingOperation",
    value: function isUndoingOperation(operation) {
      return this._undoPairs.has(operation);
    }
    /**
     * Checks whether given `operation` has been undone by any other operation.
     *
     * @param {module:engine/model/operation/operation~Operation} operation Operation to check.
     * @returns {Boolean} `true` if given `operation` has been undone any other operation, `false` otherwise.
     */

  }, {
    key: "isUndoneOperation",
    value: function isUndoneOperation(operation) {
      return this._undoneOperations.has(operation);
    }
    /**
     * For given `undoingOperation`, returns the operation which has been undone by it.
     *
     * @param {module:engine/model/operation/operation~Operation} undoingOperation
     * @returns {module:engine/model/operation/operation~Operation|undefined} Operation that has been undone by given
     * `undoingOperation` or `undefined` if given `undoingOperation` is not undoing any other operation.
     */

  }, {
    key: "getUndoneOperation",
    value: function getUndoneOperation(undoingOperation) {
      return this._undoPairs.get(undoingOperation);
    }
  }]);

  return History;
}();

export { History as default };